export default "__VITE_ASSET__SbI3qr7W__"